export default "__VITE_ASSET__BTlf9nKq__"